import { Directive, HostListener, Optional, Self } from "@angular/core";
import { NgControl } from "@angular/forms";
import { DateService } from "../services/date.service";

@Directive({
  selector: "[PastedValidDateDirective]"
})
export class PastedValidDateDirective {

  constructor(
    private dateService: DateService,
    @Optional() @Self() private ngControl: NgControl
  ) { }

  @HostListener("paste", ["$event"])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    let pastedData: string = event.clipboardData?.getData("text") || "";
    let dateStr: string = this.dateService.getDateString(pastedData);
    if (!!!dateStr) {
      this.ngControl?.control?.setValue("");
    } else {
      this.ngControl?.control?.setValue(dateStr);
    }
  }

}
